module.exports = __webpack_public_path__ + "static/home-slideshow-01@2x-b8616385b8d65865c486b3ead95b3745.jpg";